<template>
  <div
    v-if="$store.getters.loadingApp !== 1"
    class="d-flex justify-space-around"
  >
    <v-card 
      flat
      class="pa-12 mt-12"
      width="100%"
      max-width="210mm"
      min-height="297mm"
    >
      <span
        class="ma-2"
        v-html="messageHTML"
      />
    </v-card>
  </div>
</template>

<script>

import decUtil from '@/utils/decimalUtils';

export default {
    data () {
        return {
            dialog_application: false,
            year: null,
            messageHTML: "",
        }
    },
    computed: {
    },

    watch: {
    },
    beforeCreate () {
        this.$store.dispatch('setLoadingApp', 1)
    },
    async created() {
        let breadcrumb = JSON.parse(JSON.stringify(this.$store.state.breadcrumbs));
        if (breadcrumb[breadcrumb.length - 1] !== 'AnnualReport') {
            breadcrumb.push('AnnualReport')
            this.$store.dispatch('breadcrumbs', breadcrumb);
        }
        this.year = JSON.parse(JSON.stringify(this.$store.state.dataForReport.year));
        this.$store.dispatch('saveDataForReport', );
        await this.createReport();
        this.$vuetify.goTo(0);
        this.$store.dispatch('setLoadingApp', 0);
    },
    mounted() {
        let breadcrumb = JSON.parse(JSON.stringify(this.$store.state.breadcrumbs));
        if (breadcrumb[0] === 'Invoice') {
            this.$router.push({ name: 'Leads' })
        }
    },
    methods: {

        aggregateByType(items) {
            let totals = {
                totalSoles: 0,
                totalDollars: 0,
                solesPositive: [],
                dollarsPositive: [],
                solesNegative: [],
                dollarsNegative: []
            };

            for (let i = 0; i < items.length; i++) {
                const item = items[i];

                // Ensure numeric values to prevent string concatenation
                const rawAmount = Number(item.amount) || 0;
                const rawExchange = Number(item.exchangeRate) || 1;
                const isSoles = item.currency === 'S/.';
                const amount = isSoles ? rawAmount : rawAmount * rawExchange;

                if (isSoles) {
                    totals.totalSoles += rawAmount;
                } else {
                    totals.totalDollars += amount;
                }

                const type = item.type_id;

                if (!totals.solesPositive[type]) totals.solesPositive[type] = 0;
                if (!totals.dollarsPositive[type]) totals.dollarsPositive[type] = 0;
                if (!totals.solesNegative[type]) totals.solesNegative[type] = 0;
                if (!totals.dollarsNegative[type]) totals.dollarsNegative[type] = 0;

                if (rawAmount >= 0) {
                    if (isSoles) {
                        totals.solesPositive[type] += rawAmount;
                    } else {
                        totals.dollarsPositive[type] += amount;
                    }
                } else {
                    if (isSoles) {
                        totals.solesNegative[type] += rawAmount;
                    } else {
                        totals.dollarsNegative[type] += amount;
                    }
                }
            }

            return totals;
        },

        async createReport() {
            let payload = {
                year: this.year,
            }
            let incomeYear = await this.$store.dispatch('getIncomeYear', payload);
            let outgoingsYear = await this.$store.dispatch('getOutgoingsYear', payload);
            let typesIncome = await this.$store.dispatch('getTypesIncome');
            let typesOutgoings = await this.$store.dispatch('getTypesOutgoings');

            const ingresos = this.aggregateByType(incomeYear);

            const egresos = this.aggregateByType(outgoingsYear);

            // HTML version
            let messageHeader = "<div>Annual Report " + this.year + "</div>"
            var messageBody = null;
            messageBody = "<div style='margin-bottom: 1cm; font-size: 12px;'><table style='width: 100%;'>" +
            "<tr style='height:20px'></tr>" +
            "<colgroup>" +
            "<col span='1' style='width: 35%;'>" +
            "<col span='1' style='width: 35%;'>" +
            "<col span='1' style='width: 15%;'>" +
            "<col span='1' style='width: 15%;'>" +
            "</colgroup>" +
            "<tr><th style='text-align: left; text-indent: 10px'>Total Ingresos Registrados</th><th style='text-align: left;'></th><th style='text-align: left;'></th><th style='text-align: left;'></th></tr>";
            
            messageBody += "<tr><td style='text-indent: 10px'>Soles </td><td>" + decUtil.format(ingresos.totalSoles) + "</td><td> PEN</td><td></td></tr>";
            messageBody += "<tr><td style='text-indent: 10px'>Dollars * tdc </td><td>" + decUtil.format(ingresos.totalDollars,0) + "</td><td> PEN</td><td></td></tr>";
            messageBody += "<tr style='height:20px'></tr>";
            for (let index = 0; index < typesIncome.length; index++) {
                const typeId = typesIncome[index].id;

                const hasValues =
                    ingresos.solesPositive[typeId] ||
                    ingresos.dollarsPositive[typeId] ||
                    ingresos.solesNegative[typeId] ||
                    ingresos.dollarsNegative[typeId];

                if (!hasValues) {
                    messageBody += "<tr><td style='text-indent: 0px'>" + typesIncome[index].name + "</td><td> - NOT USED - </td><td></td><td></td></tr>";
                } else {
                    if (typesIncome[index].obsolete !== null) {
                        if (
                            ingresos.solesPositive[typesIncome[index].id] !== 0 ||
                            ingresos.dollarsPositive[typesIncome[index].id] !== 0 ||
                            ingresos.solesNegative[typesIncome[index].id] !== 0 ||
                            ingresos.dollarsNegative[typesIncome[index].id] !== 0
                        ) {
                            messageBody += "<tr><td style='text-indent: 0px'>" + typesIncome[index].name + "</td><td> - OBSOLETE - </td><td></td><td></td></tr>";
                        }
                    } else {
                        messageBody += "<tr><td style='text-indent: 0px'>" + typesIncome[index].name + " (" + typesIncome[index].categoryName + ")" + "</td><td></td><td></td><td></td></tr>";
                    }
                    // Refactored block: display income type rows
                    const typeId = typesIncome[index].id;
                    const rows = [
                        { label: 'Soles positive', value: ingresos.solesPositive[typeId] },
                        { label: 'Dollars positive * tdc', value: ingresos.dollarsPositive[typeId] },
                        { label: 'Soles negative', value: ingresos.solesNegative[typeId] },
                        { label: 'Dollars negative * tdc', value: ingresos.dollarsNegative[typeId] },
                    ];
                    rows.forEach(row => {
                        if (row.value !== 0) {
                            messageBody += "<tr><td></td><td style='text-indent: 10px'>" + row.label + "</td><td style='text-align: right'>" + decUtil.format(row.value) + "</td><td> PEN</td></tr>";
                        }
                    });
                }
                messageBody += "<tr style='height:20px'></tr>";
            }

            // spacing + header for Egresos
            messageBody += "<tr style='height:20px'></tr>";

            messageBody += "<tr><th style='text-align: left; text-indent: 10px'>Total Egresos Registrados</th><th></th><th></th><th></th></tr>";

            [
                { label: 'Soles', value: egresos.totalSoles },
                { label: 'Dollars * tdc', value: egresos.totalDollars }
            ].forEach(row => {
                messageBody += "<tr><td style='text-indent: 10px'>" + row.label + " </td><td>" + decUtil.format(row.value) + "</td><td> PEN</td><td></td></tr>";
            });

            messageBody += "<tr style='height:20px'></tr>";
            for (let index = 0; index < typesOutgoings.length; index++) {
                const type = typesOutgoings[index];
                const typeId = type.id;

                const hasValues =
                    egresos.solesPositive[typeId] ||
                    egresos.dollarsPositive[typeId] ||
                    egresos.solesNegative[typeId] ||
                    egresos.dollarsNegative[typeId];

                if (!hasValues) {
                    messageBody += "<tr><td style='text-indent: 0px'>" + type.name + "</td><td> - NOT USED - </td><td></td><td></td></tr>";
                } else {
                    if (type.obsolete !== null) {
                        messageBody += "<tr><td style='text-indent: 0px'>" + type.name + "</td><td> - OBSOLETE - </td><td></td><td></td></tr>";
                    } else {
                        messageBody += "<tr><td style='text-indent: 0px'>" + type.name + " (" + type.categoryName + ")" + "</td><td></td><td></td><td></td></tr>";
                    }

                    const rows = [
                        { label: 'Soles positive', value: egresos.solesPositive[typeId] },
                        { label: 'Dollars positive * tdc', value: egresos.dollarsPositive[typeId] },
                        { label: 'Soles negative', value: egresos.solesNegative[typeId] },
                        { label: 'Dollars negative * tdc', value: egresos.dollarsNegative[typeId] },
                    ];

                    rows.forEach(row => {
                        if (row.value !== 0) {
                            messageBody += "<tr><td></td><td style='text-indent: 10px'>" + row.label + "</td><td style='text-align: right'>" + decUtil.format(row.value) + "</td><td> PEN</td></tr>";
                        }
                    });
                }

                messageBody += "<tr style='height:20px'></tr>";
            }

            messageBody += "</table></div>";
            
            let messageFooter = "<div>-- end of report --</div>"
            this.messageHTML = messageHeader + messageBody + messageFooter;
            return;
        },
    },
}
</script>

<style>
    .v-card__title {
        color: #35b729;
        word-break: normal !important;
    }
    .v-card__subtitle { padding-top: 0; padding-bottom: 0;}
    .pos_absolute {
        position: absolute;
    }
    /* @media all {
        .page-break	{ display: none; }
    }
    @media print {
        .page-break	{ display: block; page-break-before: always; }
    } */
</style>